<template>
  <div class="InformationList">
    <TopNavigation :TopAct="'4'"/>
    <div :class="this.$store.state.webNavigator=='pc'?'':'pan110'">
      <listTopImg :imgType="'3'"/>
      <div class="marginAuto" :class="this.$store.state.webNavigator=='pc'?'':''">
        <articlePage  :listType="informationType"
                      :classType="'A7'"
                      :key="keys"
                      :active="types"
                      :pageIndex="current"
                      :toLeveListPath="toLeveListPath"
                      @getTotal="getTotal"/>
        <Pagination :total="total" :display="12" :current-page='current' @pagechange="getPage"/>
      </div>
    </div>
    <FooterNavigation />
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import articlePage from '../listPage/articlePage/articlePage';
import listTopImg from '../../components/listTopImg/listTopImg';
import Pagination from '../../components/Pagiantion/Pagination';
export default {
  name: 'InformationList',
  components: {TopNavigation, FooterNavigation, articlePage, listTopImg, Pagination, },
  data () {
    return {
      informationType: '',
      keys: 1,
      // 分页数据
      total: 1,
      current: 1,
      pageText: '',
      types: '0',
      toLeveListPath: 'InformationList',
    };
  },
  title () {
    return {
      title: '减肥方法|减肥食谱|减肥知识|瘦身秘诀-脂玫乐',
      keywords: '减肥方法，减肥食谱，减肥知识，瘦身秘诀，体质管理，营养管理，作息管理',
      description: '脂玫乐减肥知识，为您提供健康瘦身知识、健康减肥方法以及瘦身秘诀。',
    };
  },
  watch: {
    $route () {
      this.current = parseInt(this.$route.params.html.split('-')[2]);
      this.informationType = this.$route.params.html.split('-')[0];
      this.types = this.$route.params.html.split('-')[1];
      this.keys += 1;
    },
  },
  methods: {
    pathTlt (data) { // 子栏目标题
      this.pathtlt = data;
      this.keys += 1;
    },
    getTotal (data) {
      this.total = data;
    },
    getPage (data) {
      this.$router.push({path: '/' + this.$route.path.split('/')[1] + '/' + this.$route.params.html.split('-')[0] + '-' + this.$route.params.html.split('-')[1] + '-' + data + '-' + this.$route.params.html.split('-')[3], });
    },
  },
  mounted () {
    this.pageText = sessionStorage.getItem('pageText');
    this.current = parseInt(this.$route.params.html.split('-')[2]);
    this.informationType = this.$route.params.html.split('-')[0];
    this.types = this.$route.params.html.split('-')[1];
    this.keys += 1;
  },
};
</script>



// WEBPACK FOOTER //
// InformationList.vue